// @flow
export const defaultProps = {
  nested: false,
};



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/Form/InnerForm/InnerForm.common.js